import React from "react";
import { Wrapper, ScoreTop, ScoreBottom, ScoreBox } from "./styled";
import pluralize from "../utils/pluralize";

function ScoreOverlay({ score }) {
  return (
    <Wrapper>
      <ScoreBox>
        <ScoreTop>+{score}</ScoreTop>
        <ScoreBottom>{pluralize(score, "балл", "балла", "баллов")}</ScoreBottom>
      </ScoreBox>
    </Wrapper>
  );
}

export default ScoreOverlay;
